import script from "./return-docs.vue?vue&type=script&lang=ts&setup=true"
export * from "./return-docs.vue?vue&type=script&lang=ts&setup=true"

import "./return-docs.vue?vue&type=style&index=0&id=1ca68064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca68064"]])

export default __exports__